import styled from 'styled-components';
import { media, layout, remCalc } from 'src/components/base';
import { Link } from 'react-router-dom';

const FLEX_GRID_ROW = `
  max-width: 71.42857rem;
  margin-right: auto;
  margin-left: auto;
  display: flex;
  flex-flow: row wrap;
`;

export const Container = styled.div`
  ${media.smallOnly`
    padding-left: ${remCalc(12)};
    padding-right: ${remCalc(12)};
  `}
`;

export const Header = styled.div`
  ${FLEX_GRID_ROW}
`;

export const Body = styled.div`
  ${FLEX_GRID_ROW}
  color: ${p => p.theme.colors.base500};

  span {
    display: block;
  }
`;

export const Footer = styled.div`
  ${FLEX_GRID_ROW}
  ${media.mediumUp`
    margin-top: ${layout.margins.component.desktop.rem};
    margin-bottom: ${layout.margins.component.desktop.rem};
  `}
  ${media.smallOnly`
    margin-top: ${layout.margins.component.mobile.rem};
    margin-bottom: ${layout.margins.component.mobile.rem};
  `}
`;

export const ProductLink = styled(Link)`
  color: ${p => p.theme.text.callToAction};
  text-decoration: underline;

  &:hover {
    color: ${p => p.theme.text.callToActionHover};
  }
`;
